module.exports = {"title":"Ролик о&nbsp;последствиях строительства <br/>водного пути&nbsp;Е40","description":"","credits":["<em>Над роликом работали</em>: Алексей Белоус, Ольга Полевикова, Александра Давыденко, Марианна Рудакова, Ольга Каскевич, Константин Чикалов, Егор Квартальный","<em>Анимация</em>: <a href='https://vimeo.com/search?q=kniknistudio'>Knikni studio</a>"]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/film.ru.json
// module id = 161
// module chunks = 0